import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';

import './App.css';


// Set up locatisation for dates
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en-gb';

import { createTheme, ThemeProvider } from '@mui/material/styles';
const theme = createTheme({
  typography: {
    fontFamily: '"Figtree", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  palette: {
    primary: {
      main: '#004677'
    },
    secondary: {
      main: '#F6A704'
    },
    text: {
      primary: '#004677'
    }
  }
});

// COMPONENTS
import { AuthContextProvider } from './context/AuthContext';


// PAGES
import ApplicantManager from './pages/ApplicantManager'
import AuthPage from './pages/AuthPage'
import PurchaseData from './pages/PurchaseData'

// REACT QUERY
import {
  QueryClient,
  QueryClientProvider,
  QueryCache
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ✅ globally default to infinite and don't refetch on window focus!
      // You have to invalidate the query to refetch
      staleTime: Infinity, // As the Documents are not changing
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.state.data !== undefined) console.log('QUERY ERROR:', error);
    },
  }),
});

// const authConfig: BrowserAuthOptions = {
const authConfig = {
  clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
};
if (import.meta.env.VITE_AZURE_TENANT_ID) {
  authConfig.authority = `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`;
}

// const msalConfig: Configuration = {
const msalConfig = {
  auth: authConfig,
};
const pca = new PublicClientApplication(msalConfig);




// const App: React.FC = () => {
function App() {


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>

      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={pca}>
          <AuthContextProvider>
            <ReactQueryDevtools />

            <ThemeProvider theme={theme}>
              <BrowserRouter>

                <Routes>
                  <Route path="/" element={
                    <ApplicantManager />
                  } />
                  <Route path="/login" element={<ApplicantManager isLoginRoute={true} />} />
                  <Route path="/purchase-data" element={<PurchaseData />} />
                  <Route
                    path="/documents"
                    element={<AuthPage />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/" replace={true} />}
                  />
                </Routes>
              </BrowserRouter>
            </ThemeProvider>
          </AuthContextProvider>
        </MsalProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  )
}

export default App
